export const exitStyles = {
	// Main container styles
	mainContainer: (mobileScreen, isDark) => ({
		minHeight: '100vh',
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: mobileScreen ? '3rem' : '3rem',
		paddingBottom: mobileScreen ? '3rem' : '3rem',
		marginTop: mobileScreen ? '1.5rem' : '3rem',
		marginBottom: mobileScreen ? '1.5rem' : '3rem',
		overflowY: 'auto',
		backgroundColor: isDark ? '#161616' : 'transparent',
		'&::-webkit-scrollbar': {
			width: '2px',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: isDark ? '#7A8185' : '#d3d3d3',
			borderRadius: '1px',
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: isDark ? '#2D2D2D' : '#f5f5f5',
		},
	}),

	// Inner content box styles
	contentBox: (mobileScreen, desktopScreen, isDark) => ({
		width: mobileScreen ? '90%' : '40%',
		textAlign: 'center',
		border: desktopScreen ? `1px solid ${isDark ? '#7A8185' : '#D9D9D9'}` : 'none',
		minHeight: mobileScreen ? '50vh' : '70vh',
		maxHeight: mobileScreen ? '70vh' : '80vh',
		padding: mobileScreen ? '1.5rem' : '2rem',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		borderRadius: '8px',
		backgroundColor: isDark ? '#161616' : 'transparent',
	}),

	// FIP logos container styles
	logosContainer: (mobileScreen) => ({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		mb: 2,
		mt: mobileScreen ? 2 : 20,
		gap: 0,
	}),

	// Individual FIP logo avatar styles
	fipAvatar: (index, fipIdsLength, isDark) => ({
		width: 30,
		height: 30,
		marginRight: index < Math.min(fipIdsLength, 5) - 1 ? '-6px' : '0',
		border: `.5px solid ${isDark ? '#7A8185' : '#D9D9D9'}`,
		backgroundColor: isDark ? '#2D2D2D' : 'white',
		zIndex: index + 1,
		'& .MuiAvatar-img': {
			objectFit: 'contain',
			padding: '2px',
		},
	}),

	// "+X more" avatar styles
	moreAvatar: (isDark) => ({
		width: 60,
		height: 30,
		marginRight: '0',
		marginLeft: '-6px',
		border: `.5px solid ${isDark ? '#7A8185' : 'grey'}`,
		backgroundColor: isDark ? '#2D2D2D' : 'white',
		color: isDark ? '#7A8185' : 'text.secondary',
		fontSize: '0.75rem',
		fontWeight: 600,
		zIndex: 6,
		borderRadius: '15px',
	}),

	// Title styles
	titleText: (isDark) => ({
		mb: 2,
		fontSize: '1.2rem',
		color: `${isDark ? '#FFFFFF' : '#000000'} !important`,
		'&.MuiTypography-root': {
			color: `${isDark ? '#FFFFFF' : '#000000'} !important`,
		},
	}),

	errorText: (isDark) => ({
		fontSize: '1.2rem',
		color: 'error.main',
		fontWeight: 600,
		mb: 1.5,
		'&.MuiTypography-root': {
			color: 'error.main !important',
		},
	}),

	// Body text styles
	bodyText: (isDark) => ({
		mb: 5,
		color: `${isDark ? '#FFFFFF' : '#000000'} !important`,
		'&.MuiTypography-root': {
			color: `${isDark ? '#FFFFFF' : '#000000'} !important`,
		},
	}),

	// Button container styles
	buttonContainer: (mobileScreen) => ({
		mt: mobileScreen ? 1 : 1,
	}),

	// Go back button styles
	goBackButton: (mobileScreen, primaryColor) => ({
		mt: 2,
		mb: 2,
		maxWidth: mobileScreen ? '90%' : '50%',
		marginX: 'auto',
		borderColor: primaryColor,
		borderRadius: '8px',
	}),

	// Footer container styles
	footerContainer: (isDark) => ({
		position: 'fixed',
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 1000,
		backgroundColor: isDark ? '#161616' : 'white',
		boxShadow: isDark ? '0 -2px 10px rgba(255, 255, 255, 0.1)' : '0 -2px 10px rgba(0, 0, 0, 0.1)',
		'& > *': {
			margin: 0,
			padding: '2rem',
		},
	}),
};
